import Callout from './VerticalSteps';

export default Callout;
